import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Notification = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 20 20"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path
      d="M8.11035 17.7971C8.47155 18.4706 9.18229 18.9287 9.99999 18.9287C10.8177 18.9287 11.5284 18.4706 11.8897 17.7971"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.0892 2.69137C7.12643 1.65414 8.53321 1.07143 10.0001 1.07143C11.4669 1.07143 12.8737 1.65414 13.911 2.69137C14.9482 3.7286 15.5309 5.13538 15.5309 6.60226C15.5309 7.46534 15.6733 8.27634 15.8876 9.10587C15.9476 9.29366 16.0138 9.47086 16.0849 9.63803C16.4163 10.4177 17.3289 10.6837 18.0099 11.1878C19.0263 11.9403 18.8298 13.5503 17.9843 14.1754C17.9843 14.1754 16.6193 15.3571 10.0001 15.3571C3.38074 15.3571 2.01577 14.1754 2.01577 14.1754C1.17036 13.5503 0.973858 11.9403 1.99025 11.1878C2.67118 10.6837 3.58375 10.4178 3.91528 9.6381C4.24574 8.86095 4.46925 7.86681 4.46925 6.60226C4.46925 5.13538 5.05197 3.7286 6.0892 2.69137Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
